import Vue from 'vue'

const eventHub = new Vue()

Vue.prototype.$eventHub = eventHub

export default eventHub
